import React from "react";
import { Modal, TextField, Button } from "components";

const DateFilterModal = ({
  openDateModal,
  setOpenDateModal,
  handleChange,
  startDate,
  endDate,
  startDateName,
  endDateName,
  onButtonClick,
}) => {
  return (
    <Modal showModal={openDateModal} onClose={() => setOpenDateModal(false)}>
      <div className="row pt-4">
        <div className="col-sm-6">
          <TextField
            name={startDateName || "startDate"}
            id="startDate"
            value={startDate}
            onChange={handleChange}
            type="date"
            label="From"
            size="sm"
            required={false}
          />
        </div>
        <div className="col-sm-6">
          <TextField
            name={endDateName || "endDate"}
            id="endDate"
            value={endDate}
            onChange={handleChange}
            type="date"
            label="To"
            size="sm"
            required={false}
          />
        </div>
      </div>
      <div style={{ margin: "3rem auto", width: "fit-content" }}>
        <Button
          label="Apply"
          size="sm"
          disabled={startDate > endDate || (!startDate && !endDate)}
          onClick={onButtonClick}
        />
      </div>
    </Modal>
  );
};

export default DateFilterModal;
